import { Flex, Box } from "orcs-design-system";
import React from "react";

import * as placeholder from "src/components/Placeholder/PlaceholderStyles";

const LoadingBlock = () => {
  return (
    <Box data-testid="groups-navigation-loading-block">
      <Flex flexDirection="column" gap="xs" my="xs">
        <placeholder.Line width={250} height={24} />
        <placeholder.Line width={250} height={24} />
        <placeholder.Line width={250} height={24} />
      </Flex>
    </Box>
  );
};

export default LoadingBlock;
